export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9142.89e8a6f5.jpg";